import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { AppInfoService } from 'core/app-info/app-info.service';
import { DialogData } from 'core/dialog/dialog-data.class';
import { DialogService } from 'core/dialog/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

@Injectable()
export class UnsavedChangesGuard {
  appStrings: AppLocalization;

  constructor(
    private dialogService: DialogService,
    private matDialogService: MatDialog,
    private appInfoService: AppInfoService,
  ) {
    this.appStrings = this.appInfoService.appStrings;
  }

  canDeactivate(component: CanComponentDeactivate) {
    // Allow navigation if the component says that it is OK or it doesn't have a canDeactivate function
    if (!component.canDeactivate || component.canDeactivate()) {
      return true;
    }

    return new Observable((observer: Observer<boolean>) => {
      const dialogParams: DialogData = {
        title: this.appStrings.unsavedChangesTitle,
        content: this.appStrings.unsavedChangesMessage,
        buttons: [
          { label: this.appStrings.button_leave, style: 'primary leave-button' },
          { label: this.appStrings.button_stay, style: 'secondary', focused: true },
        ]
      };

      const dialogRef = this.dialogService.openDialog(dialogParams);
      dialogRef.afterClosed().subscribe(dialogAnswer => {
        const userLeaves = dialogAnswer === 0; // leave if the first button pressed, stay if second
        observer.next(userLeaves);
        observer.complete();

        if (userLeaves) {
          this.matDialogService.openDialogs.forEach(dialog => dialog.close());
        }
      });
    });
  }
}
